<sm-title-bar pageTitle="Employee details" [showBackButton]="true"></sm-title-bar>

<div class="booking_details_df" *ngIf="!loader">
  <!--  -->
  <div class="row">
     <div class="col-sm-8">
        <div class="row">
           <div class="col-sm-6">
              <div class="booking_card_tt">
                 <mat-card  (click)="openSalary()">
                    <div class="price_gd">
                       <h4>{{employeeCountData[0].net_pay ? employeeCountData[0].net_pay.toFixed(2) : '0.00'}}</h4>
                    </div>
                    <div class="booking_icon">
                       <img src="../../../../assets/images/Salary.png" alt="icon">
                    </div>
                    <div class="booking_headingtt">
                       <h3>Salary</h3>
                       <p>Record new salary and view old records. Track employee costs to company.
                     </p>
                    </div>
                    <div class="onhover_arrow">
                     <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                   </div> 
                 </mat-card>
              </div>
           </div>
           <div class="col-sm-6">
              <div class="booking_card_tt">
                 <mat-card  (click)="openSalarySettings()">
                  <div class="salary_mark">
                     <mat-icon *ngIf="employeeCountData[0].is_setting && employeeCountData[0].is_setting ==1">check</mat-icon>
                     <mat-icon *ngIf="!employeeCountData[0].is_setting || employeeCountData[0].is_setting ==0" style="color: #D70D0D;">close</mat-icon>
                  </div>
                  <!-- 2nd -->
                  <!-- <div class="salary_mark">
                     <mat-icon>close</mat-icon>
                  </div> -->
                 
                    <div class="booking_icon">
                       <img src="../../../../assets/images/Salary-settings.png" alt="icon">
                    </div>
                    <div class="booking_headingtt">
                       <h3>Salary settings</h3>
                       <p>Configure the parameters of salary for quick record keeping and disbursement.</p>
                    </div>
                    <div class="onhover_arrow">
                     <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                </div>
                 </mat-card>
              </div>
           </div>
           <div class="col-sm-6">
              <div class="booking_card_tt">
                 <mat-card (click)="openCredits()">
                    <div class="price_gd">
                       <h4>{{employeeCountData[0].credit_amount ? employeeCountData[0].credit_amount.toFixed(2) : '0.00'}}</h4>
                    </div>
                    <div class="booking_icon">
                       <img src="../../../../assets/images/Pay-credits.png" alt="icon">
                    </div>
                    <div class="booking_headingtt">
                       <h3>Pay credits</h3>
                       <p>Track and add records of credits/advance to employees. Update pay-outs.</p>
                    </div>
                    <div class="onhover_arrow">
                     <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                </div>
                 </mat-card>
              </div>
           </div>
           <div class="col-sm-6">
              <div class="booking_card_tt">
                 <mat-card (click)="openMessages()">
                    <div class="price_gd">
                       <h4 style="font-size: 16px;font-weight: normal;">{{employeeCountData[0].last_message_date ? (employeeCountData[0].last_message_date | date) : ''}}</h4>
                    </div>
                    <div class="booking_icon">
                       <img src="../../../../assets/images/Messages.png" alt="icon">
                    </div>
                    <div class="booking_headingtt">
                       <h3 >Messages</h3>
                       <p>Start instant communication with the in-built messaging system in real time.</p>
                    </div>
                    <div class="onhover_arrow">
                     <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                </div>
                 </mat-card>
              </div>
           </div>
           <div class="col-sm-6">
              <div class="booking_card_tt">
                 <mat-card  (click)="openDutyLogs()">
                    <div class="price_gd">
                       <h4>{{employeeCountData[0].duty_status ? (employeeCountData[0].duty_status | titlecase) : ''}}</h4>
                    </div>
                    <div class="booking_icon">
                       <img src="../../../../assets/images/Duty-logs.png" alt="icon">
                    </div>
                    <div class="booking_headingtt">
                       <h3>Duty logs</h3>
                       <p>In and out data with location information. Evaluate performance and reliability.</p>
                    </div>
                    <div class="onhover_arrow">
                     <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                </div>
                 </mat-card>
              </div>
           </div>

           <div class="col-sm-6">
              <div class="booking_card_tt" (click)="openaccesscontrol()">
                 <mat-card>
                  <!-- <div class="salary_mark">
                     <mat-icon>check</mat-icon>
                  </div> -->
                    <div class="booking_icon">
                       <img src="../../../../assets/images/secure-access.png" alt="icon">
                    </div>
                    <div class="booking_headingtt">
                       <h3>Access control</h3>
                       <p>Get to know about the current pack's status, expiry and renew options.</p>
                    </div>
                    <div class="onhover_arrow">
                     <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                </div>
                 </mat-card>
              </div>
           </div>
           
           <!-- <div class="col-sm-6">
              <div class="booking_card_tt">
                 <mat-card>
                  <div class="salary_mark">
                     <mat-icon>check</mat-icon>
                  </div>
                    <div class="booking_icon">
                       <img src="../../../../assets/images/Subscription-Renew.png" alt="icon">
                    </div>
                    <div class="booking_headingtt">
                       <h3>Subscription & Renew</h3>
                       <p>Get to know about the current pack's status, expiry and renew options.</p>
                    </div>
                    <div class="onhover_arrow">
                     <mat-icon class="hover-icon"> arrow_forward</mat-icon>
                </div>
                 </mat-card>
              </div>
           </div> -->

        </div>
     
   
     </div>
     <div class="col-sm-4">
      <div class="salon_mei_section">
          <mat-card>
             <div class="exert_opd">
          <div class="salon_img">
            <div class="marl_section" *ngIf="employeeData[0].status == 1"></div>
            <div class="marl_section_red" *ngIf="employeeData[0].status == 0"></div>
              <img [src]="employeeData[0].employee_thumb_image" onerror="this.src='../../../../assets/images/user-avatar.svg'" alt="">
          </div>
          <div class="hair_ct_heading">
              <div class="rahul_headert">
              <h4>{{employeeData[0].employee_name}}</h4>
              <p> {{employeeData[0].employee_address.address_line}}</p>
            </div>
          </div>

          <div class="rahul_headert">
              <div class="option_ser">
                <button mat-icon-button [matMenuTriggerFor]="homeMenu">
                    <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #homeMenu="matMenu">
                    <button mat-menu-item (click)="editEmployee(employeeData[0])"> <mat-icon>edit</mat-icon> Edit</button>
                    <button mat-menu-item (click)="setEmployeeStatus(0)" *ngIf="employeeData[0].status == 1">  <mat-icon>no_accounts</mat-icon> De-activate temporaily</button>
                    <button mat-menu-item (click)="setEmployeeStatus(1)" *ngIf="employeeData[0].status == 0">  <mat-icon>no_accounts</mat-icon> Activate employee</button>
                    <button mat-menu-item (click)="deleteEmployee()"> <mat-icon>disabled_by_default</mat-icon>Remove Employee</button>
                    <button mat-menu-item (click)="employeeplan()" >  <mat-icon>loyalty</mat-icon> Subscription & Renew</button>
                  </mat-menu>
            </div>
            <div class="new_employ">
            <p>Mobile: {{employeeData[0].country_code}} {{employeeData[0].employee_phone}}</p>
            <p> DOB - {{employeeData[0].dob ? (employeeData[0].dob | date) : 'No info available'}}</p>
          </div>
          <div class="new_employ">
            <p>Joining: {{employeeData[0].date_of_join ? (employeeData[0].date_of_join | date) : 'No info available'}}</p>
          </div>
          </div>
       </div>
          <div class="active_cardt" *ngIf="employeeData[0].subscription_status == 1">
             <p><mat-icon>check_circle</mat-icon> Active employee subscription.</p>
          </div>
          <div class="inactive_cardt" *ngIf="employeeData[0].subscription_status == 0">
             <p><mat-icon>cancel</mat-icon> Inactive employee subscription.</p>
          </div>
      </mat-card>
      </div>
     </div>

  </div>
</div>